/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import { ClearIndicator as CompiledClearIndicator, clearIndicatorCSS as compiledClearIndicatorCSS, DropdownIndicator as CompiledDropdownIndicator, dropdownIndicatorCSS as compiledDropdownIndicatorCSS, LoadingIndicator as CompiledLoadingIndicator, loadingIndicatorCSS as compiledLoadingIndicatorCSS } from '../compiled/components/indicators';

// ==============================
// Dropdown & Clear Buttons
// ==============================

export var dropdownIndicatorCSS = function dropdownIndicatorCSS(props) {
  return compiledDropdownIndicatorCSS();
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/React.createElement(CompiledDropdownIndicator, props);
};
export var clearIndicatorCSS = function clearIndicatorCSS(props) {
  return compiledClearIndicatorCSS();
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var ClearIndicator = function ClearIndicator(props) {
  return /*#__PURE__*/React.createElement(CompiledClearIndicator, props);
};

// ==============================
// Loading
// ==============================

export var loadingIndicatorCSS = function loadingIndicatorCSS(props) {
  return compiledLoadingIndicatorCSS();
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var LoadingIndicator = function LoadingIndicator(props) {
  return /*#__PURE__*/React.createElement(CompiledLoadingIndicator, props);
};